import axios from 'axios';
import { BlogPost, mapWPPost } from '../interface/blog.interface';

const WP_API_URL = process.env.REACT_APP_BLOG_API_URL || 'https://blog.staging.baoafrik.com/wp-json/wp/v2';


class BlogService {
  private axiosInstance = axios.create({
    baseURL: WP_API_URL,
    timeout: 15000,
  });

  /**
   * Fetch all blog posts from WordPress
   * @param limit Number of posts to fetch
   * @returns Array of normalized BlogPost objects
   */
  public async getPosts(limit: number = 10): Promise<BlogPost[]> {
    try {
      const response = await this.axiosInstance.get('/posts', {
        params: {
          _embed: true,
          per_page: limit,
          status: 'publish',
        },
      });
      
      if (Array.isArray(response.data)) {
        return response.data.map(mapWPPost);
      }
      return [];
    } catch (error) {
      console.error('Error fetching blog posts:', error);
      throw error;
    }
  }

  /**
   * Fetch a single blog post by its slug
   * @param slug The post slug
   * @returns The normalized BlogPost object or null
   */
  public async getPostBySlug(slug: string): Promise<BlogPost | null> {
    try {
      const response = await this.axiosInstance.get('/posts', {
        params: {
          _embed: true,
          slug: slug,
        },
      });

      if (Array.isArray(response.data) && response.data.length > 0) {
        return mapWPPost(response.data[0]);
      }
      return null;
    } catch (error) {
      console.error(`Error fetching blog post with slug ${slug}:`, error);
      throw error;
    }
  }
}

export const blogService = new BlogService();
